import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { HisBaseGlobalsService, HisUiService } from 'hisng';

import { BudgetSourceService } from 'app/fs/res/finance/service/budget-source/budget-source.service';
import { ResearchContract, ResearchContractIncome } from 'app/fs/res/common/model/finance/research-contract-classes';
import { FinancingTypeValueService } from 'app/fs/res/common/service/financing-type/financing-type-value.service';

@Component( {
    selector: 'res-edit-research-contract-income-dialog',
    templateUrl: './edit-research-contract-income-dialog.component.html',
} )
export class EditResearchContractIncomeDialogComponent implements OnInit {
    @Input() researchContractIncome: ResearchContractIncome;
    @Input() researchContracts: ResearchContract[];
    @Input() hisDdKeyPrefix: string;
    @Input() editIndex: number;
    @Input() visibility: boolean;
    @Output() visibilityChange: EventEmitter<boolean> = new EventEmitter();
    @Output() researchContractIncomeChange: EventEmitter<ResearchContractIncome> = new EventEmitter();

    public filteredOptions: string[] = []; // filtered options

    constructor( private hisUiService: HisUiService,
        public hisBaseGlobalsService: HisBaseGlobalsService,
        private financingTypeValueService: FinancingTypeValueService,
        private budgetSourceService: BudgetSourceService ) {
    }

    ngOnInit() {
        if ( this.editIndex === null && this.researchContracts.length === 1) {
            this.researchContractIncome.budgetSourceName = this.researchContracts[0].budgetSource.defaulttext;
        }
    }

    /* close dialog action */
    public closeDialog() {
        this.visibilityChange.emit(false);
    }

    public applyChanges() {
        this.financingTypeValueService.validateResearchsFundIncomes( this.hisDdKeyPrefix.split('_')[1],
            this.researchContractIncome ).subscribe(
            ( isValid: number ) => {
                if( isValid === 0 ) {
                    this.researchContractIncomeChange.emit( this.researchContractIncome );
                    this.closeDialog();
                }
            } );
    }

    /* completeMethod() implementation of <p-autoComplete> to filter inputs. */
    public completeMethod( event: { query: string } ) {
        this.filteredOptions = this.budgetSourceService.getTypesOfObject( this.researchContracts, event.query );
    }

}
